import './App.css';
import React, { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import VerificationOtp from './VerificationOtp';
import { Toaster } from 'react-hot-toast';
import { socket, SocketContext } from './socket';
import 'react-photo-view/dist/react-photo-view.css';
import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;
export const config = {
  Accept: 'application/json',
  headers: {
    // Authorization: `Bearer ${token}`,
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
};

function App() {
  useEffect(() => {
    handleFetchDomainDetails();
  }, []);

  const handleFetchDomainDetails = async () => {
    const hostId = window.location.host.split('.').slice(-2).join('.');
    const res = await axios.get(`${baseURL}/internal/accounts/fetch-hosts/${hostId}`, {
      ...config,
      params: { _ts: Date.now() },
      headers: {
        ...config.headers,
        'Cache-Control': 'no-store, no-cache, must-revalidate, max-age=0',
        Pragma: 'no-cache',
        Expires: '0',
        'If-Modified-Since': '0',
      },
    });
    if (res?.data?.status === 'success') {
      const domainDetails = res?.data?.data[0];
      if (domainDetails) {
        localStorage.setItem('h_name', domainDetails?.name);
        localStorage.setItem('h_url', domainDetails?.logo);
        document.title = domainDetails?.name;
        const newLink = document.createElement('link');
        newLink.rel = 'icon';
        newLink.href = domainDetails?.logo;
        document.head.appendChild(newLink);
      } else {
        localStorage.removeItem('h_name');
        localStorage.removeItem('h_url');
        document.title = 'SalesCaptain';
        const newLink = document.createElement('link');
        newLink.rel = 'icon';
        newLink.href = 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2024-10-15/webchat_1728990607600.png';
        document.head.appendChild(newLink);
      }
    }
  };
  return (
    <SocketContext.Provider value={socket}>
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
      <Routes>
        <Route path="/:compName/:numberKey" element={<VerificationOtp />} />
      </Routes>
    </SocketContext.Provider>
  );
}

export default App;
